import PropTypes from 'prop-types';
import { Component } from 'react';
import lodash from 'lodash';

import styles from './FilePreview.scss';
import DateTime from 'common/components/DateTime/DateTime';
import { DEFAULT_DATETIME_INPUT_FORMAT } from 'common/util/dateTime';

class FilePreview extends Component {

    constructor(...args) {
        super(...args);
        this.onDesktopClick = this.onDesktopClick.bind(this);
        this.onMobileClick = this.onMobileClick.bind(this);
    }

    isMobileButtonVisible() {
        const { mobileButtonSection } = this;
        if (lodash.isNil(mobileButtonSection)) {
            return false;
        }
        return mobileButtonSection.offsetHeight > 0;
    }

    onDesktopClick(e) {
        if (this.isMobileButtonVisible()) {
            return;
        }
        const { onClick, viewDocumentPermission } = this.props;
        viewDocumentPermission ? onClick() : null ;
    }

    onMobileClick(e) {
        if (!this.isMobileButtonVisible()) {
            return;
        }
        const { onClick, viewDocumentPermission } = this.props;
        viewDocumentPermission ? onClick() : null ;
    }

    render(){
        const { document, viewDocumentPermission } = this.props;

        if(lodash.isNil(document)){
            return null;
        }
        const {
            name,
            documentIdentifier,
            documentType,
            uploadUser,
            uploadDate,
            signatures
        } = document;

        const documentTypeDisplay = (documentType && documentType.id)
            ? (
                <section className={styles.detailsItem} data-cy="FilePreview">
                    <span className={styles.detailsLabel}>Document Type: </span>
                    <span className={styles.detailsContent}>{ documentType.displayName }</span>
                </section>
            )
            : null;
        const viewDocumentPermissionStyle = viewDocumentPermission ? `${styles.file}` : `${styles.fileNoPermission}`;
        return (
            <article className={viewDocumentPermissionStyle} onClick={this.onDesktopClick} data-cy="FilePreview-onDesktopClick">
                <section className={styles.headerSection}>
                    <div className={styles.icon} />
                    <header className={styles.header} data-cy="FilePreview-name">
                        { name }
                    </header>
                </section>
                <section className={styles.detailsSection}>
                    <section className={styles.detailsItem}>
                        <span className={styles.detailsLabel}>File ID</span>
                        <span className={styles.detailsContent} data-cy="FilePreview-documentIdentifier">{ documentIdentifier }</span>
                    </section>
                    { documentTypeDisplay }
                    <section className={styles.detailsItem}>
                        <span className={styles.detailsLabel}>Uploaded By</span>
                        <span className={styles.detailsContent} data-cy="FilePreview-displayName">{ uploadUser.displayName }</span>
                    </section>
                    <section className={styles.detailsItem}>
                        <span className={styles.detailsLabel}>Email Address</span>
                        <span className={styles.detailsContent} data-cy="FilePreview-emailAddress">{ uploadUser.emailAddress }</span>
                    </section>
                    <section className={styles.detailsItem}>
                        <span className={styles.detailsLabel}>Upload Date</span>
                        <span className={styles.detailsContent} data-cy="FilePreview-DateTime">
                            <DateTime value={uploadDate} inputFormat={DEFAULT_DATETIME_INPUT_FORMAT} time={false} applyTimezoneOffset={true}/>
                        </span>
                    </section>
                    <section className={styles.detailsItem}>
                        <span className={styles.detailsLabel}>Signatures</span>
                        <span className={styles.detailsContent} data-cy="FilePreview-Signatures">({signatures ? signatures.length : 0})</span>
                    </section>
                </section>
                <section className={styles.mobileButtonSection}
                    ref={e => this.mobileButtonSection = e}>
                    <button type="button" onClick={this.onMobileClick} data-cy="FilePreview-onMobileClick">Open File</button>
                </section>
            </article>
        );
    }
}

FilePreview.propTypes = {
    document: PropTypes.shape({
        name: PropTypes.string,
        uploadUser: PropTypes.shape({
            displayName: PropTypes.string,
            emailAddress: PropTypes.string
        }),
        documentType: PropTypes.shape({
            id: PropTypes.string,
            displayName: PropTypes.string
        }),
        uploadDate: PropTypes.string,
        signatures: PropTypes.array,
    }),
    onClick: PropTypes.func
};

export default FilePreview;
